import { UserProfile } from '../login/redux/types';
import { Amount } from '../main/deals/redux/types';

export const emailValidation = (email: string | undefined | null) => {
    email = email && email.trim();
    let mailformat = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*(\.\w{2,10})+$/;
    if (email && email.match(mailformat)) {
        return true;
    } else {
        return false;
    }
};

export const checkPasswordStrength = (password: string) => {
    if (password.length === 0) {
        return -1;
    }

    let matchedCase = [];
    matchedCase.push('[$@$!%*#?&]'); // Special Charector
    matchedCase.push('[A-Z]'); // Uppercase Alpabates
    matchedCase.push('[0-9]'); // Numbers
    matchedCase.push('[a-z]'); // Lowercase Alphabates

    let ctr = 0;
    for (let i = 0; i < matchedCase.length; i++) {
        if (new RegExp(matchedCase[i]).test(password)) {
            ctr++;
        }
    }

    switch (ctr) {
        case 0:
        case 1:
        case 2:
            return 0;
        case 3:
            return 1;
        case 4:
            return 2;
        default:
            return 2;
    }
};

function chunkString(str: string, length: number) {
    return str.match(new RegExp('.{1,' + length + '}', 'g'));
}

export const commaSeperator = (rawText: string) => {
    try {
        const indexOfNeg = rawText.indexOf('-');
        rawText = rawText.replace('-', '');
        const text = String(rawText);
        let arr = text.split('.');
        let integerStr = arr[0];
        let decimalStr = text.indexOf('.') > 0 ? '.' : '';
        if (arr[1]) {
            decimalStr += arr[1];
        }
        const mob = integerStr.length % 3;
        const head = mob > 0 ? integerStr.substring(0, mob) : '';
        const rest = integerStr.substring(mob);
        let body = '';
        if (rest) {
            const chunked = chunkString(rest, 3);
            if (chunked) {
                body = chunked.join(',');
            }
        }
        const result = head + `${mob > 0 && rest ? ',' : ''}` + body + decimalStr;

        return indexOfNeg !== -1 ? `-${result}` : result;
    } catch (e) {
        return rawText;
    }
};

export const formatNumber = (num: number) => {
    if (Math.abs(num) >= 1.0e12) {
        return (Math.abs(num) / 1.0e12).toFixed(2) + 'T';
    } else if (Math.abs(num) >= 1.0e9) {
        return (Math.abs(num) / 1.0e9).toFixed(2) + 'B';
    } else if (Math.abs(num) >= 1.0e6) {
        return (Math.abs(num) / 1.0e6).toFixed(2) + 'M';
    } else if (Math.abs(num) >= 1.0e3) {
        return (Math.abs(num) / 1.0e3).toFixed(2) + 'K';
    } else {
        return Math.abs(num);
    }
};

export const instanceOfAmount = (object: any): object is Amount => {
    if (!!object && typeof object === 'object') {
        return 'amountUpto2dp' in object && 'currency' in object;
    }
    return false;
};

export const checkIsNumber = (str: string) => {
    try {
        if (str === 'N/A' || !str) {
            str = '-99999';
        }
        if (parseFloat(str.replaceAll(',', ''))) {
            return true;
        }
        return false;
    } catch (err) {
        return false;
    }
};

/**
 * Get the full name of the user.
 * @param userProfile
 * @returns
 */
export const getUserFullName = (userProfile?: UserProfile) => {
    if (!userProfile) return '';

    const { firstName, lastName } = userProfile;
    return `${firstName} ${lastName}`.trim();
};

/**
 * Checks if user profile is complete.
 * @param userProfile
 * @returns
 */
export const isUserProfileComplete = (userProfile?: UserProfile) => {
    return !!(
        userProfile &&
        userProfile.firstName &&
        userProfile.lastName &&
        userProfile.phoneNumber &&
        userProfile.phoneNumber.number &&
        userProfile.phoneNumber.countryCode
    );
};
